import * as BECaller from '../../util/apiCaller';
import { setError } from '../App/ErrorsActions';

// Export Constants
export const TENANT_LOADING = 'TENANT_LOADING',
  TENANT_DATA = 'TENANT_DATA';

export function error(err) {
  return setError(err);
}

export function handleError(err) {
  return setError(err, { log: false });
}

export function successTenant(data) {
  return {
    type: TENANT_DATA,
    payload: {
      loaded: true,
      data
    }
  };
}

export function getTenant() {
  return (dispatch) => {
    dispatch({ type: TENANT_LOADING, payload: true });
    BECaller.api('tenant/config', 'get').then(
      (data) => {
        dispatch(successTenant(data))
      },
      (err) => {
        dispatch({ type: TENANT_LOADING, payload: false });
        dispatch(handleError(err))
      }
    )
  };
}

export function setTenant(data) {
  return (dispatch) => {
    dispatch({ type: TENANT_LOADING, payload: true });
    BECaller.api('tenant/config', 'post', data).then(
      (data) => {
        dispatch(successTenant(data))
      },
      (err) => {
        dispatch({ type: TENANT_LOADING, payload: false });
        dispatch(handleError(err))
      }
    )
  };
}

export function joinTenant(data) {
  return (dispatch) => {
    dispatch({ type: TENANT_LOADING, payload: true });
    BECaller.api('tenant/join', 'post', data).then(
      (data) => {
        dispatch(successTenant(data))
      },
      (err) => {
        dispatch({ type: TENANT_LOADING, payload: false });
        dispatch(handleError(err))
      }
    )
  };
}
